module.exports = function() {
  return new Worker(__webpack_public_path__ + "eef8a36abe5f044aa10f.worker.js");
};